import * as theme from "../theme";

import { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import GoogleAddressAutoComplete from "../components/GoogleAddressAutoComplete";
import HeaderText from "../components/HeaderText";
import Context from "../contexts/data";

const Address = () => {
  const { address, handleUpdateFormValue, navigate, fullQueryString } = useContext(Context);

  const handleNextStep = () => {
    if (!address) {
      handleUpdateFormValue("errorMessage", "Please enter your address.");
      return;
    } else {
      navigate("user-name", "Address");
    }
  };

  return (
    <Wrapper>
      <HeaderText
        bigger_text={"What is your address?"}
        smaller_text={"For verification only."}
      />
      <GoogleAddressAutoComplete />
      <TextContainer>
        <Text>
          Can't find the address?{" "}
          <Link to={`/manual-address${fullQueryString}`}>
            Enter it manually
          </Link>
        </Text>
      </TextContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  @media (max-width: ${theme.mobile}) {
    margin-bottom: 16px;
  }
`;

const TextContainer = styled.div`
  /* margin: 16px 0px; */
`;

const Text = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  > a {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    text-decoration: none;
    color: #0da6f2;
  }
`;

export default Address;
